<template>
    <div class="collection-view">
        <div class="collection-header">
            {{ langTransfer('文章') }}
        </div>
        <div ref="collectionBodyWarpper" class="collection-body-warpper">
            <div class="collection-body">
                <div class="collection-list">

                    <div v-for="(item,index) in articlesData.Data"
                         :key="index"
                         class="collection-item"
                         @click="goTextReading(item)">
                        <h5>{{ item.Title }}</h5>
                        <div class="item-infos">
                            <img v-if="item.__cover" :src="item.__cover">
                            <div class="text-infos">
                                <p class="text-summary">
                                    {{ item.Summary }}
                                </p>
                                <p class="text-base">
                                    {{ `${ item.MagazineName }&nbsp;&nbsp;&nbsp; ${item.__yearIssue}` }}
                                </p>
                                <div v-show="item.FavoriteID !== undefined"
                                     class="collection-icon"
                                     @click.stop="collectionBtnClick(item)">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="14px"
                                         height="14px"
                                         viewBox="0 0 14 14"
                                         version="1.1">
                                        <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
                                        <title>收藏</title>
                                        <desc>Created with Sketch.</desc>
                                        <g id="页面-1"
                                           stroke="none"
                                           stroke-width="1"
                                           fill="none"
                                           fill-rule="evenodd">
                                            <g id="我的收藏"
                                               :fill="item.FavoriteID === 0 ? 'gray': themeColor"
                                               transform="translate(-1242.000000, -318.000000)">
                                                <g id="hot" transform="translate(440.000000, 140.000000)">
                                                    <g id="item1" transform="translate(34.000000, 82.000000)">
                                                        <g id="收藏" transform="translate(768.000000, 96.000000)">
                                                            <path d="M11.1284106,13.9998229 C11.077377,
                                                            13.9998229 11.0263434,13.9871667 10.9796347,
                                                            13.9613856 L6.99987786,11.7648387 L3.02055353,
                                                            13.9613856 C2.91329644,14.0209165 2.78182002,
                                                            14.0110728 2.6832127,13.9356046 C2.58460538,
                                                            13.8606051 2.53530173,13.733106 2.55606116,
                                                            13.6070131 L3.315943,8.95376479 L0.0969330106,
                                                            5.65847561 C0.00957038132,5.56894499 -0.0220012605,
                                                            5.43535219 0.0156252209,5.3139468 C0.0536841836,
                                                            5.19207265 0.153588961,5.10347953 0.274253183,
                                                            5.08472967 L4.72325974,4.40598447 L6.71270567,
                                                            0.172264412 C6.82039524,-0.0574214707 7.17979297,
                                                            -0.0574214707 7.28705005,0.172264412 L9.27692846,
                                                            4.40598447 L13.725935,5.08472967 C13.8465992,
                                                            5.10347953 13.946504,5.19207265 13.984563,
                                                            5.3139468 C14.021757,5.43535219 13.9906178,
                                                            5.56894499 13.9032552,5.65847561 L10.6838127,
                                                            8.95376479 L11.4441271,13.6070131 C11.4648865,
                                                            13.733106 11.4151503,13.8606051 11.3169755,
                                                            13.9356046 C11.2611845,13.9782605 11.1950138,
                                                            13.9998229 11.1284106,13.9998229 Z"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <!-- <img v-show="item.ID !== undefined "
                                     :src="item.ID !== 0 ?
                                     require('@/assets/hasCollectioned.png') : require('@/assets/collection.png')"
                                     class="collection-icon"
                                     @click="collectionBtnClick(item)"> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="site-footer">
                    <Footer/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        props: {
        },
        data () {
            return {
                collectionBScroll: null,
                articlesData: [],
                dataPageIndex: 1
            }
        },
        computed: {
            userInfos () {
                return this.$store.state.userInfos
            },
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        mounted () {
            this.initBScroll()
            this.getUserFavLists()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.collectionBScroll = new BScroll(this.$refs.collectionBodyWarpper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 150
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.collectionBScroll.on('pullingUp', () => {
                        try {
                            this.pullingUpHandler()
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            async getUserFavLists () {
                try {
                    const { dataPageIndex } = this
                    const data = await this.$apis('user').getCollectionLists(dataPageIndex)
                    data.Data.forEach((e) => {
                        e.__yearIssue = `${ e.Year }年${ (`0${ e.Issue }`).substr(-2) }期`
                        e.__cover = e.Images[0] ? e.Images[0].URL : ''
                    })
                    if (dataPageIndex !== 1) {
                        data.Data = this.articlesData.Data.concat(data.Data)
                        this.$nextTick(() => {
                            this.collectionBScroll.finishPullUp()
                        })
                    }
                    this.articlesData = data
                } catch (error) {
                    console.log(error)
                }
            },
            pullingUpHandler () {
                const { Data, ItemCount } = this.articlesData
                if (Data.length < ItemCount) {
                    this.dataPageIndex += 1
                    this.getUserFavLists()
                }
            },
            collectionBtnClick (item) {
                const { FavoriteID } = item
                if (FavoriteID !== 0) {
                    this.removeFromCollection(item)
                } else {
                    this.addToCollection(item)
                }
            },
            async addToCollection (item) {
                try {
                    const {
                        ArticleID
                    } = item
                    item.FavoriteID = undefined
                    const formData = {
                        resourcekind: 101,
                        resourceid: ArticleID
                    }
                    const data = await this.$apis('user').addToBookCase(formData)
                    if (data.Code === 1) {
                        item.FavoriteID = data.Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async removeFromCollection (item) {
                try {
                    const {
                        ArticleID
                    } = item
                    item.FavoriteID = undefined
                    const formData = {
                        resourcekind: 101,
                        resourceid: ArticleID
                    }
                    const data = await this.$apis('user').removeFromCollection(formData)
                    if (data.Code === 1) {
                        item.FavoriteID = 0
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            goTextReading (item) {
                const params = {
                    resourceType: 'magazine',
                    id: item.MagazineID,
                    year: item.Year,
                    issue: item.Issue,
                    articleId: item.ArticleID,
                    token:'token'
                }
                this.$router.push({
                    name: 'textReading',
                    params
                })
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { userInfos } = vm.$store.state
                if (!userInfos) {
                    vm.$router.push({
                        path: '/'
                    })
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .collection-view {
        width: 850px;
        position: absolute;
        top: 20px;
        left: 290px;
        bottom: 20px;
        box-sizing: border-box;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .collection-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding-left: 16px;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;
        
        font-size: 16px;
        color: #1A1A1A;
        line-height: 50px;
    }

    .collection-body-warpper {
        width: 100%;
        overflow: hidden;
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
    }

    .collection-body {
        position: relative;
        width: 850px;
        min-height: 100%;
        box-sizing: border-box;
        padding: 16px 34px 128px;
    }

    .site-footer {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .collection-item {
        width: 100%;
        height: 142px;
        box-sizing: border-box;
        border-bottom: 1px solid #F0F2F7;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        cursor: pointer;

        h5 {
            
            font-size: 18px;
            color: #1A1A1A;
            letter-spacing: 0;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
        }

        .item-infos {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;

            img {
                width: 130px;
                height: 80px;
                margin-right: 10px;
            }
        }

        .text-infos {
            position: relative;
            height: 80px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            .text-summary {
                width: 100%;
                height: 60px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                
                font-size: 14px;
                color: #79808B;
                letter-spacing: 0;
                text-align: justify;
            }

            .text-base {
                
                font-size: 12px;
                color: #8590A6;
                letter-spacing: 0;
            }

            .collection-icon {
                width: 14px;
                height: 14px;
                position: absolute;
                bottom: 0;
                right: 0;
                cursor: pointer;
            }
        }
    }

    .collection-item:last-child {
        border-bottom: none;
    }
</style>
